import "./App.css";
import Header from "./components/header/Header";
import SimpleMap from "./components/map/SimpleMap";
import List from "./components/list/List";
import { useEffect, useState } from "react";
import { getData, getWeatherData } from "./api/index.js";
import useWindowWidth from "./hooks/useWindowWidth";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import { Transition } from "react-transition-group";
import LinearProgress from "@mui/material/LinearProgress";

function App() {
  const [childClick, setChildClick] = useState(null);
  const [places, setPlaces] = useState([]);
  const [filtered, setFiltred] = useState([]);
  const [coord, setCoord] = useState({});
  const [bounds, setBounds] = useState({});
  const [load, setLoad] = useState(true);
  const [type, setType] = useState("restaurants");
  const [rate, setRate] = useState(0);
  const [selected, setSelected] = useState(false);
  const [width, setWidth] = useWindowWidth();
  const [zoom, setZoom] = useState();
  const [weather, setWeather] = useState([]);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      ({ coords: { latitude, longitude } }) => {
        setCoord({
          lat: latitude,
          lng: longitude,
        });
      }
    );
  }, []);

  useEffect(() => {
    if (bounds.sw && bounds.ne && zoom > 8) {
      setLoad(true);
      getData(type, bounds.sw, bounds.ne).then((res) => {
        setPlaces(res?.filter((place) => place.name && place.num_reviews > 0));
        setFiltred([]);
        setLoad(false);
      });
      getWeatherData(coord.lat, coord.lng).then((data) => {
        setWeather(data);
      });
    }
    setFiltred([]);
  }, [type, bounds]);

  useEffect(() => {
    const fl = places?.filter((place) => place?.rating >= rate);
    setFiltred(fl);
  }, [rate]);

  return (
    <>
      <div className='w-screen h-screen flex flex-col font-["Rowdies"] text-xs text-[#333] overflow-hidden'>
        {width !== "s" ? (
          <div className="w-full h-[100vh] flex flex-row">
            <div className="basis-1/4">
              <List
                places={filtered?.length ? filtered : places}
                load={load}
                setRate={setRate}
                setType={setType}
                childClick={childClick}
                type={type}
                width={width}
              />
            </div>
            <div className="basis-3/4">
              <SimpleMap
                coord={coord}
                setCoord={setCoord}
                childClick={childClick}
                setChildClick={setChildClick}
                setZoom={setZoom}
                setBounds={setBounds}
                places={filtered?.length ? filtered : places}
                width={width}
                weather = {weather}
              />
            </div>
          </div>
        ) : (
          <div className="flex-grow w-full flex flex-col h-full relative">
            <div className="h-screen">
              <SimpleMap
                coord={coord}
                setCoord={setCoord}
                childClick={childClick}
                setChildClick={setChildClick}
                setZoom={setZoom}
                setSelected={setSelected}
                setBounds={setBounds}
                places={filtered?.length ? filtered : places}
                width={width}
                weather = {weather}
              />
            </div>
            <div
              style={{
                transition: "top .3s ease-in-out",
              }}
              className="trans h-screen z-[300] w-full overflow-hidden absolute top-[70%] transition-all delay-1000"
            >
              <IoIosArrowUp
                className="text-[1.5rem] mx-auto animate-bounce "
                onClick={(e) => {
                  e.currentTarget.parentElement.classList.remove("top-[70%]");
                  e.currentTarget.nextElementSibling.classList.remove("hidden");
                  e.currentTarget.classList.remove("animate-bounce");
                  e.currentTarget.classList.add("hidden");
                }}
              />
              <IoIosArrowDown
                className="text-[1.5rem] mx-auto mt-1 hidden animate-bounce"
                onClick={(e) => {
                  e.currentTarget.classList.remove("hidden");
                  e.currentTarget.previousElementSibling.classList.remove(
                    "hidden"
                  );
                  e.currentTarget.previousElementSibling.classList.add(
                    "animate-bounce"
                  );
                  e.currentTarget.parentElement.classList.add("top-[70%]");
                  e.currentTarget.classList.add("hidden");
                }}
              />
              <List
                places={filtered?.length ? filtered : places}
                load={load}
                setRate={setRate}
                setType={setType}
                childClick={childClick}
                type={type}
                width={width}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default App;
